module.exports = __webpack_public_path__ + "static/media/400335_02.12f8f668.png";